<div class="ipm-info-dialog" [class.has-terms]="terms.length">
  <div class="info-icon">
    <i [class]="icon"></i>
  </div>
  <h3 class="info-title" *ngIf="title">{{ title }}</h3>
  <p class="info-message" *ngIf="message && !terms.length" [innerHTML]="message"></p>
  <dl class="info-terms" *ngIf="terms.length">
    <div class="info-term" *ngFor="let term of terms">
      <dt class="term-label">{{ term.label }}</dt>
      <dd class="term-message" [innerHTML]="term.message"></dd>
    </div>
  </dl>
  <button class="info-close-btn" type="button" (click)="close()">Close</button>
</div>
